import getApi from '../../../api'
import { singleItemPageLimit } from '../../../constants'
import { Filters } from '../../../model/Filters'
import { PaginatedList } from '../../../model/Pagination'
import { Team } from '../../../model/Team'

export const getTeams = (
  page: number,
  filters?: Filters,
  signal?: AbortSignal,
  limit = singleItemPageLimit,
) =>
  getApi().get<PaginatedList<Team>>(
    `/admin/teams`,
    {
      page,
      limit,
      ...filters,
    },
    { signal },
  )
